export default "__VITE_ASSET__KpnFa28$__"